/* eslint-disable import/prefer-default-export */
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import { TOI_FEED_DOMAIN } from '../../constants';
import makeRequest from '../../utils/makeRequest';

const reducerName = 'cricketScorecard';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const RECEIVE_MATCH_STATUS = createActionName('RECEIVE_MATCH_STATUS');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');

function receiveLiveblogCricketScorecardData(data) {
  return {
    type: RECEIVE_DATA,
    payload: data,
  };
}

function receiveLiveblogCricketMatchStatus(data) {
  return {
    type: RECEIVE_MATCH_STATUS,
    payload: data,
  };
}

function handleLiveblogCricketScorecardDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}

function fetchLiveblogCricketScorecardData(params) {
  const url = `${TOI_FEED_DOMAIN}/cricket/node/scorecard-${params.msid}.json`;
  return makeRequest.get(url);
}

export function loadLiveblogCricketScorecardData(params) {
  return dispatch =>
    fetchLiveblogCricketScorecardData(params)
      .then(data => {
        dispatch(receiveLiveblogCricketScorecardData(data.data));
        const matchStatus = {};
        matchStatus.currentInning = data.data.currentInning;
        matchStatus.matchStatus = data.data.matchStatus;
        matchStatus.matchType = data.data.matchType;
        dispatch(receiveLiveblogCricketMatchStatus(matchStatus));
      })
      .catch(error => dispatch(handleLiveblogCricketScorecardDataError(error)));
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case RECEIVE_DATA:
      return {
        ...state,
        data: action.payload,
        timestamp: Date.now(),
      };
    case RECEIVE_MATCH_STATUS:
      return {
        ...state,
        matchStatus: action.payload,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
